
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparCross as ObiBuoySparCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-cross.js';
 
 
 

 
 export const ObiBuoySparCross = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-cross',
   elementClass: ObiBuoySparCrossElement,
   events: {
     
   }
  });
 
 